import './shim/process-env';
import { initSwiper } from './swiper';
import { initObf } from './obf';
import { initLazyLoading } from './lazy-loading';
import { initInformationBanner } from './information-banner';

initLazyLoading();
initSwiper();
initObf();
initInformationBanner();
